import type { Ruolo } from '@aulaviva/shared';

/** Pagina di atterraggio dopo l'accesso, per ruolo. */
export function homePerRuolo(ruolo: Ruolo): string {
  switch (ruolo) {
    case 'admin':
      return '/admin';
    case 'relatore':
      return '/relatore';
    case 'regia':
      return '/regia';
    default:
      return '/';
  }
}
